import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
@Injectable({ providedIn: "root" })
export class ApiHttpService {
  BASE_URL = environment.API;

  constructor(
    private http: HttpClient
  ) {}

  public get(url: string, options?: any) {
    return this.http.get(this.BASE_URL + url, options);
  }

  public post(url: string, data: any, options?: any) {
    return this.http.post(this.BASE_URL + url, data, options);
  }

  public patch(url: string, data?: any, options?: any) {
    return this.http.patch(this.BASE_URL + url, data, options);
  }

  public put(url: string, data: any, options?: any) {
    return this.http.put(this.BASE_URL + url, data, options);
  }

  public delete(url: string, options?: any) {
    return this.http.delete(this.BASE_URL + url, options);
  }
}
